

import {
  FETCH_PRINTER_REQUEST,
  FETCH_PRINTER_SUCCESS,
  FETCH_PRINTER_FAILURE,
  CREATE_PRINTER_REQUEST,
  CREATE_PRINTER_SUCCESS,
  CREATE_PRINTER_FAILURE,
  UPDATE_PRINTER_REQUEST,
  UPDATE_PRINTER_SUCCESS,
  UPDATE_PRINTER_FAILURE,
  DELETE_PRINTER_REQUEST,
  DELETE_PRINTER_SUCCESS,
  DELETE_PRINTER_FAILURE,
} from "./PrinterActionType";

export const fetchPrinterRequest = () => ({
  type: FETCH_PRINTER_REQUEST,
});

export const fetchPrinterSuccess = (data, dataType) => ({
  type: FETCH_PRINTER_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchPrinterFailure = (error) => ({
  type: FETCH_PRINTER_FAILURE,
  payload: error,
});

export const createPrinterRequest = () => ({
  type: CREATE_PRINTER_REQUEST,
});

export const createPrinterSuccess = (data, dataType) => ({
  type: CREATE_PRINTER_SUCCESS,
  payload: { data, type: dataType },
});

export const createPrinterFailure = (error) => ({
  type: CREATE_PRINTER_FAILURE,
  payload: error,
});

export const updatePrinterRequest = () => ({
  type: UPDATE_PRINTER_REQUEST,
});

export const updatePrinterSuccess = (data, dataType) => ({
  type: UPDATE_PRINTER_SUCCESS,
  payload: { data, type: dataType },
});

export const updatePrinterFailure = (error) => ({
  type: UPDATE_PRINTER_FAILURE,
  payload: error,
});

export const deletePrinterRequest = () => ({
  type: DELETE_PRINTER_REQUEST,
});

export const deletePrinterSuccess = (data, dataType) => ({
  type: DELETE_PRINTER_SUCCESS,
  payload: { data, type: dataType },
});

export const deletePrinterFailure = (error) => ({
  type: DELETE_PRINTER_FAILURE,
  payload: error,
});
